import React, { useEffect, useRef, useState } from "react";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
import { Button, Chip, Switch } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CompanyVeiwController from "../../redux/actions/companyApiActions";
import "../../styles/styles.css";
import "../../styles/layout.css";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import AddAnnouncement from "./addAnnouncement";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import ViewAnnouncementDialog from "./ViewAnnouncementDialog";
import { IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ExportButton from "../../components/ag grid/ExportButton";
import usePermission from "../../utils/usePermission";
import { getUserInfoFromToken } from "../../utils/authUtils";
const AnnouncementList = () => {
  const dispatch = useDispatch();
  const gridRef = React.useRef(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [editAnnouncement, setEditAnnouncement] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const { hasPermission } = usePermission();
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  // const userType = localStorage.getItem("user_type");


  const { getAnnouncement, updateAnnouncement, deleteAnnouncement } =
    CompanyVeiwController();
  const { announcement } = useSelector((state) => state.company);

  useEffect(() => {
    dispatch(getAnnouncement());
  }, []);

  const formikRef = useRef();
              useEffect(() => {
              const { userType, userId } = getUserInfoFromToken();
              setUserType(userType);
              setUserId(userId);
            }, []);
  
  const handleDelete = (id) => {
    dispatch(deleteAnnouncement(id));
  };

  const openModalForCreate = () => {
    setEditAnnouncement(null);
    setShowModal(true);
  };

  const openModalForEdit = (announcement) => {
    setEditAnnouncement(announcement);
    setShowModal(true);
  };
  const handleView = (data) => {
    setViewData(data);
    setShowViewModal(true);
  };
  const refreshList = () => {
    dispatch(getAnnouncement());
  };

  const canCreateAnnouncement = hasPermission("notifications", "create");
  const canExportAnnouncement = hasPermission("notifications", "export");

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 50,
      pinned: "left",
      colId: "checkboxColumn"
    },
    {
      headerName: "SR No.",
      valueGetter: "node.rowIndex + 1",
      width: 100
    },

    { headerName: "Title", field: "title", flex: 1 },
    {
      headerName: "Message",
      editable: true,
      field: "message",
      flex: 1,
      cellRenderer: (params) => {
        const maxLength = 15; // Limit to 50 characters
        const value = params.value || "";
        const truncated =
          value.length > maxLength
            ? value.substring(0, maxLength) + "..."
            : value;
        return truncated;
      }
    },
    {
      headerName: "Created At",
      field: "created_at",
      flex: 1,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
          year: "numeric"
        });
      }
    },
    {
      headerName: "Active",
      field: "active",
      flex: 0.5,
      cellRenderer: (params) => {
        const handleChange = (e) => {
          const updatedValue = e.target.checked;
          const updatedData = {
            ...params.data,
            active: updatedValue
          };

          // Update the grid UI immediately
          params.node.setDataValue("active", updatedValue);

          // Dispatch update API call
          dispatch(updateAnnouncement(params.data.id, updatedData))
            .then(() => {
              console.log("Update successful");
            })
            .catch((err) => {
              console.error("Update failed", err);
            });
        };

        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Switch
              checked={params.value}
              onChange={handleChange}
              color="primary"
              size="medium"
            />
          </div>
        );
      }
    },
    {
      headerName: "Actions",
      field: "actions",
      flex: 1,
      headerClass: "ag-header-center",
      cellStyle: { display: "flex", justifyContent: "center" },
      cellRenderer: (params) => (
        <div style={{ display: "flex", gap: "4px", justifyContent: "center" }}>
          <Tooltip title="View">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleView(params.data)}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          {( userType === "Admin"||hasPermission("notifications", "edit")) && (
          <Tooltip title="Edit">
            <IconButton
              sx={{ color: "#808080" }}
              size="small"
              onClick={() => openModalForEdit(params.data)}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
          )}
          {(userType === "Admin"|| hasPermission("notifications", "delete")) && (
          <Tooltip title="Delete">
            <IconButton
              sx={{ color: "#d32f2f" }}
              size="small"
              onClick={() => handleDelete(params.data)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
          )}
        </div>
      )
    }
  ];

  return (
    <div>
      <div className="d-flex flex-wrap gap-2 mb-3" style={{ justifyContent: "space-between" }}>
        <div className="mt-2" >
          {/* {(userType === "Admin"|| hasPermission("notifications", "create")) &&( */}
          <Button
          variant="contained"
          startIcon={<AddCircleOutline />}
          onClick={openModalForCreate}
          sx={{
                borderRadius: "8px",
                backgroundColor: "#1976d2",
                textTransform: "none",
                paddingX: 2,
                height: "40px",             
                fontSize: "0.875rem",       
                minWidth: "140px",          
          }}
        >
          Add Announcement
        </Button> 
        {/* )}   */}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div>
        {(userType === "Admin"|| hasPermission("notifications", "export")) && (
        <ExportButton
              gridRef={gridRef}
              fileName="announcements.xlsx"
              exportColumns={["title", "message", "created_at", "active"]}
              disabled={selectedRows.length === 0}
            />
            )}
          </div>
          <PageSizeSelector
          pageSize={pageSize}
          onChange={(e) => setPageSize(Number(e.target.value))}
        />
        </div>
      </div>

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          columnDefs={columnDefs}
          rowData={announcement}
          gridRef={gridRef}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
          pagination={true}
          pageSize={pageSize}
        />
      </div>

      <AddAnnouncement
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editAnnouncement}
        refreshList={refreshList}
      />
      <ViewAnnouncementDialog
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        data={viewData}
      />
    </div>
  );
};

export default AnnouncementList;
